var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Container",
    [
      _c("Title", { attrs: { strong: "", bold: "" } }, [
        _vm._v(" " + _vm._s(_vm.donationPeriod) + " "),
      ]),
      _c(
        "Form",
        [
          _c(
            "FormCard",
            [
              _c("BreadCrumb", { attrs: { items: _vm.breadCrumbitems } }),
              _c("FormHeading", [
                _vm._v(" " + _vm._s(_vm.steps.DONATION_INFO) + " "),
              ]),
              _c("p", { class: _vm.$style.text }, [
                _vm._v(
                  " 姓名會作為未來捐款記錄查詢，確認後無法修改，建議儘量使用本名。 "
                ),
              ]),
              _c(
                "FormRow",
                [
                  [
                    _c("FormLabel", { attrs: { for: "donation-owner" } }, [
                      _vm._v(" 捐款名義 "),
                    ]),
                    _c("SelectInput", {
                      attrs: {
                        id: "donation-owner",
                        options: _vm.donationOwnerOptions,
                        value: _vm.donationOwner,
                        error: _vm.donationOwnerError,
                      },
                      on: {
                        "update:value": function ($event) {
                          _vm.donationOwner = $event
                        },
                      },
                    }),
                  ],
                ],
                2
              ),
              _vm.donationOwner === "團體名義"
                ? [
                    _c(
                      "FormRow",
                      [
                        _c("FormLabel", { attrs: { for: "group-title" } }, [
                          _vm._v(" 單位名稱 "),
                        ]),
                        _c("TextInput", {
                          attrs: {
                            id: "group-title",
                            value: _vm.contact.groupName,
                            error: _vm.contactGroupTitleError,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(_vm.contact, "groupName", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "FormRow",
                      [
                        _c("FormLabel", { attrs: { for: "receipt-id-no" } }, [
                          _vm._v(" 統編 "),
                        ]),
                        _c("FormLabel", { attrs: { right: "", small: "" } }, [
                          _vm._v(
                            " 非本國籍個人之身分證字號及團體統一編號無自動上傳國稅局功能，請索取紙本收據並自行辦理扣繳申報。 "
                          ),
                        ]),
                        _c("TextInput", {
                          attrs: {
                            id: "receipt-id-no",
                            "upper-case": "",
                            value: _vm.receipt.idNo,
                            error: _vm.receiptIdNoError,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(_vm.receipt, "idNo", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.donationOwner !== "匿名"
                ? [
                    _c(
                      "FormRow",
                      [
                        _c("FormLabel", { attrs: { for: "last-name" } }, [
                          _vm._v(" 聯絡人姓氏 "),
                        ]),
                        _c("TextInput", {
                          attrs: {
                            id: "last-name",
                            placeholder: "王",
                            value: _vm.contact.lastName,
                            error: _vm.contactLastNameError,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(_vm.contact, "lastName", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "FormRow",
                      [
                        _c("FormLabel", { attrs: { for: "first-name" } }, [
                          _vm._v(" 聯絡人名字 "),
                        ]),
                        _c("TextInput", {
                          attrs: {
                            id: "first-name",
                            placeholder: "大明",
                            value: _vm.contact.firstName,
                            error: _vm.contactFirstNameError,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(_vm.contact, "firstName", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.donationOwner === "個人名義"
                      ? _c(
                          "FormRow",
                          [
                            _c("FormLabel", { attrs: { for: "birthday" } }, [
                              _vm._v(" 生日 "),
                            ]),
                            _c("DateSelectInput", {
                              attrs: {
                                id: "birthday",
                                type: "full",
                                "open-date": `1990`,
                                value: _vm.contact.birthDate,
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(
                                    _vm.contact,
                                    "birthDate",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "FormRow",
                      [
                        _c("FormSubTitle", { attrs: { required: "" } }, [
                          _vm._v(" 聯絡資訊 "),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "FormRow",
                      [
                        [
                          _c("FormLabel", { attrs: { for: "email" } }, [
                            _vm.donationOwner === "團體名義"
                              ? _c("span", [_vm._v(" 聯絡人")])
                              : _vm._e(),
                            _vm._v("Email "),
                          ]),
                          _c("TextInput", {
                            attrs: {
                              id: "email",
                              placeholder: "tft@gmail.com",
                              value: _vm.contact.email,
                              error: _vm.contactEmailError,
                            },
                            on: {
                              "update:value": function ($event) {
                                return _vm.$set(_vm.contact, "email", $event)
                              },
                            },
                          }),
                        ],
                      ],
                      2
                    ),
                    _c(
                      "FormRow",
                      [
                        [
                          _c("FormLabel", { attrs: { for: "phone" } }, [
                            _vm._v(" 手機號碼 "),
                          ]),
                          _c("FormLabel", { attrs: { right: "", small: "" } }, [
                            _vm._v(
                              " 手機為查詢捐款紀錄使用，建議輸入正確號碼。格式範例：0912345678、886912345678 "
                            ),
                          ]),
                          _c("TelInput", {
                            attrs: {
                              id: "phone",
                              placeholder: "0912345678",
                              value: _vm.contact.phone,
                              error: _vm.contactPhoneError,
                            },
                            on: {
                              "update:value": function ($event) {
                                return _vm.$set(_vm.contact, "phone", $event)
                              },
                            },
                          }),
                        ],
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
              _vm.donationOwner !== "匿名"
                ? [
                    _c(
                      "FormRow",
                      [
                        _c("FormSubTitle", { attrs: { required: "" } }, [
                          _vm._v(" 收據寄送 "),
                        ]),
                        _vm.donationPeriod ===
                        _vm.donationPeriodType.DONATION_PERIOD
                          ? _c("p", { class: _vm.$style.text }, [
                              _vm._v(
                                " 「單筆電子收據」將於每月扣款成功當下隨即以 Email 寄送，「年度紙本收據」或「年度電子收據」將於每年 2、3 月期間寄送。 "
                              ),
                            ])
                          : _vm._e(),
                        _vm.donationPeriod ===
                        _vm.donationPeriodType.DONATION_SINGLE
                          ? _c("p", { class: _vm.$style.text }, [
                              _vm._v(
                                " 「單筆電子收據」將於扣款成功當下隨即以 Email 寄送，"
                              ),
                              _vm.donationOwner === "團體名義"
                                ? _c("span", [
                                    _vm._v(
                                      "「單筆紙本收據」將於隔月 10 號統一寄出，"
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(
                                "「年度紙本收據」將於每年 2、3 月期間寄送。 "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "FormRow",
                      [
                        _c("FormLabel", { attrs: { for: "receipt-type" } }, [
                          _vm._v(" 收據種類 "),
                        ]),
                        _c("SelectInput", {
                          attrs: {
                            id: "receipt-type",
                            options: _vm.receiptTypes,
                            value: _vm.receipt.type,
                            error: _vm.receiptTypeError,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(_vm.receipt, "type", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    [
                      _vm.receiptType.SINGLE_ELEC_RECEIPT,
                      _vm.receiptType.SINGLE_PAPER_RECEIPT,
                      _vm.receiptType.YEAR_ELEC_RECEIPT,
                      _vm.receiptType.YEAR_PAPER_RECEIPT,
                    ].includes(_vm.receipt.type)
                      ? [
                          _c(
                            "FormRow",
                            [
                              _c("ContentButton", {
                                attrs: {
                                  type: "import",
                                  label:
                                    _vm.donationOwner === "個人名義"
                                      ? "同上方聯絡人姓名，點擊自動帶入「收據抬頭」"
                                      : "同上方單位名稱、統編，點擊自動帶入「收據抬頭」、「收據統編/身分證字號」",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.loadDonationUser.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormRow",
                            [
                              _c(
                                "FormLabel",
                                { attrs: { for: "receipt-title" } },
                                [_vm._v(" 收據抬頭 ")]
                              ),
                              _c("TextInput", {
                                attrs: {
                                  id: "receipt-title",
                                  placeholder: "王大明",
                                  value: _vm.receipt.title,
                                  error: _vm.receiptTitleError,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    return _vm.$set(
                                      _vm.receipt,
                                      "title",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm.donationOwner === "個人名義" ||
                    (_vm.donationOwner === "團體名義" &&
                      _vm.receipt.type !== "不需要收據")
                      ? _c(
                          "FormRow",
                          [
                            _c(
                              "FormLabel",
                              { attrs: { for: "receipt-id-no" } },
                              [_vm._v(" 收據統編 / 身分證字號 ")]
                            ),
                            _c(
                              "FormLabel",
                              { attrs: { right: "", small: "" } },
                              [
                                _vm._v(
                                  " 非本國籍個人之身分證字號及團體統一編號無自動上傳國稅局功能，請索取紙本收據並自行辦理扣繳申報。 "
                                ),
                              ]
                            ),
                            _c("TextInput", {
                              attrs: {
                                id: "receipt-id-no",
                                "upper-case": "",
                                value: _vm.receipt.idNo,
                                error: _vm.receiptIdNoError,
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(_vm.receipt, "idNo", $event)
                                },
                              },
                            }),
                            _vm.donationOwner === "個人名義"
                              ? _c("CheckBoxRadioInput", {
                                  attrs: {
                                    id: "upload-etax",
                                    label: "自動上傳國稅局抵減所得稅額",
                                    disabled: !_vm.validTwId,
                                    value: _vm.receipt.etaxCheck,
                                  },
                                  on: {
                                    "update:value": function ($event) {
                                      return _vm.$set(
                                        _vm.receipt,
                                        "etaxCheck",
                                        $event
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    [
                      _vm.receiptType.SINGLE_PAPER_RECEIPT,
                      _vm.receiptType.YEAR_PAPER_RECEIPT,
                    ].includes(_vm.receipt.type)
                      ? [
                          _c(
                            "FormRow",
                            [
                              _c(
                                "FormLabel",
                                { attrs: { for: "address-city" } },
                                [_vm._v(" 縣市(請選擇) ")]
                              ),
                              _c("SelectInput", {
                                attrs: {
                                  id: "address-city",
                                  options: _vm.cities,
                                  value: _vm.receipt.mailingCity,
                                  error: _vm.receiptMailingCityError,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    return _vm.$set(
                                      _vm.receipt,
                                      "mailingCity",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.receipt.mailingCity
                            ? _c(
                                "FormRow",
                                [
                                  _c(
                                    "FormLabel",
                                    { attrs: { for: "address-district" } },
                                    [_vm._v(" 鄉鎮市區 ")]
                                  ),
                                  _c("SelectInput", {
                                    attrs: {
                                      id: "address-district",
                                      value: _vm.receipt.mailingDistrict,
                                      options: _vm.districts,
                                      error: _vm.receiptMailingDistrictError,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        return _vm.$set(
                                          _vm.receipt,
                                          "mailingDistrict",
                                          $event
                                        )
                                      },
                                      change: function ($event) {
                                        _vm.receipt.mailingZipCode = _vm.zipCode
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "FormRow",
                            [
                              _c(
                                "FormLabel",
                                { attrs: { for: "address-zipcode" } },
                                [_vm._v(" 郵遞區號 ")]
                              ),
                              _c("TextInput", {
                                attrs: {
                                  id: "address-zipcode",
                                  placeholder: "100",
                                  disabled: true,
                                  value: _vm.receipt.mailingZipCode,
                                  error: _vm.receiptZipCodeError,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    return _vm.$set(
                                      _vm.receipt,
                                      "mailingZipCode",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormRow",
                            [
                              _c(
                                "FormLabel",
                                { attrs: { for: "address-detail" } },
                                [_vm._v(" 詳細地址 ")]
                              ),
                              _c("TextInput", {
                                attrs: {
                                  id: "address-detail",
                                  placeholder: "寶慶路25號2樓",
                                  value: _vm.receipt.mailingAddress,
                                  error: _vm.receiptMailingAddressError,
                                },
                                on: {
                                  "update:value": function ($event) {
                                    return _vm.$set(
                                      _vm.receipt,
                                      "mailingAddress",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _c(
                      "FormRow",
                      [
                        _c("FormSubTitle", { attrs: { required: "" } }, [
                          _vm._v(" 其他 "),
                        ]),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.donationOwner === "匿名"
                ? [
                    _c("FormRow", [
                      _c("p", { class: _vm.$style.text }, [
                        _vm._v(
                          " 若匿名捐款，TFT會以無名氏名義開立收據，但收據將不被寄出，捐款紀錄將也無法被查詢。 "
                        ),
                      ]),
                    ]),
                  ]
                : _vm._e(),
              _vm.donationOwner !== "匿名"
                ? [
                    _c(
                      "CheckBoxRadioInput",
                      {
                        class: [_vm.checkBoxRadioInputStyle.left],
                        attrs: {
                          id: "personal-donation-list-display-name",
                          value: _vm.showOnDonationList,
                          error: _vm.showOnDonationListError,
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.showOnDonationList = $event
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: [
                              _vm.checkBoxRadioInputStyle.label,
                              _vm.showOnDonationListError &&
                                _vm.checkBoxRadioInputStyle.error,
                            ],
                          },
                          [
                            _vm._v(
                              " 我同意 TFT 依財團法人法第 25 條公開捐贈者姓名及金額之規定(若不同意公開也須勾選，並依照此 "
                            ),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openOverlay(
                                      "DonationListGuideline"
                                    )
                                  },
                                },
                              },
                              [_vm._v("說明")]
                            ),
                            _vm._v("簽署與回傳聲明書) "),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "CheckBoxRadioInput",
                      {
                        class: [_vm.checkBoxRadioInputStyle.left],
                        attrs: {
                          id: "personal-data-consent",
                          value: _vm.personalDataConsent,
                          error: _vm.personalDataConsentError,
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.personalDataConsent = $event
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: [
                              _vm.checkBoxRadioInputStyle.label,
                              _vm.personalDataConsentError &&
                                _vm.checkBoxRadioInputStyle.error,
                            ],
                          },
                          [
                            _vm._v(" 我已詳閱並同意「"),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://drive.google.com/file/d/1bVdy883rsGU087rI10oerxQrCyvUYJg0/view",
                                  target: "_blank",
                                  rel: "noopener",
                                },
                              },
                              [_vm._v("為台灣而教教育基金會個資蒐集同意書")]
                            ),
                            _vm._v("」。 "),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "CheckBoxRadioInput",
                      {
                        class: [_vm.checkBoxRadioInputStyle.left],
                        attrs: {
                          id: "personal-notification",
                          value: _vm.preferredNotification,
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.preferredNotification = $event
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { class: [_vm.checkBoxRadioInputStyle.label] },
                          [_vm._v(" 我願意收到 TFT 相關資訊 ")]
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
              _c(
                "Align",
                { attrs: { "space-between": "" } },
                [
                  _c(
                    "Button",
                    {
                      attrs: { back: "", small: _vm.isMobile },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.back()
                        },
                      },
                    },
                    [_vm._v(" 上一步 ")]
                  ),
                  _c(
                    "Button",
                    {
                      attrs: { small: _vm.isMobile },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_vm._v(" 下一步 ")]
                  ),
                ],
                1
              ),
              _c(
                "Align",
                { attrs: { right: "" } },
                [_c("Error", [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")])],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _c(
            "Overlay",
            {
              attrs: { "is-open": _vm.showDonationListGuideline },
              on: {
                close: function ($event) {
                  return _vm.closeOverlay("DonationListGuideline")
                },
              },
            },
            [
              _c("OverlayTitle", [_vm._v("財團法人法第 25 條")]),
              _c(
                "div",
                {
                  staticStyle: { "margin-top": "15px", "font-size": "1.2rem" },
                },
                [
                  _vm._v(
                    " 依財團法人法第 25 條規定，除捐款人事先表示反對外，本會需主動公開捐贈者姓名及金額。倘若捐款人不同意將捐款者姓名公開揭露，請下載「"
                  ),
                  _c(
                    "a",
                    {
                      staticStyle: { color: "#e73273" },
                      attrs: {
                        target: "_blank",
                        href: "https://drive.google.com/file/d/1Wjy7c5omeZk-chz25qfPg210UtZRJ_y0/view?usp=sharing",
                      },
                    },
                    [_vm._v("不同意捐款者姓名公開揭露聲明書")]
                  ),
                  _vm._v(
                    "」，簽名回傳至本會，以利後續作業進行。選擇不公開之捐款人，將以「王O明」方式揭露。未回覆聲明書之捐款人，依照法條規定「將捐款者姓名公開揭露」。 "
                  ),
                  _c("br"),
                  _c("br"),
                  _vm._v(
                    " 填寫完畢後，請務必回覆掃描後 E-mail 至：fin@teach4taiwan.org 標題「不同意捐款者姓名公開揭露聲明書」或郵寄至：100 台北市中正區寶慶路 25 號 2 樓（財團法人為台灣而教教育基金會 財務組 收）」。 "
                  ),
                  _c("br"),
                  _c("br"),
                  _vm._v(
                    " 如有任何問題歡迎 E-mail 至：fin@teach4taiwan.org 或來電 02-23456225，聯絡財務組。 "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }